import * as actionType from './ActionType';

const initialState = {
  errors: [],
  blockRoute: false
};

export function CommonReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SET_ERR_MSG:
      return {
        ...state,
        errors: [...state.errors, action.payload.error]
      };
    case actionType.REMOVE_ERR_MSG:
      return {
        ...state,
        errors: state.errors.filter((err) => err.id != action.payload.id)
      };
    case actionType.SET_BLOCK_ROUTE:
      return {
        ...state,
        blockRoute: action.payload.blockRoute
      };
    default:
      return state;
  }
}

export * from './CommonErrors';
export * from './RouteAction';
